import React, { useState, useEffect, useRef } from 'react';

const AddMealPlanModal = ({ isOpen, onClose, onSave }) => {
    const [title, setTitle] = useState('');
    const [error, setError] = useState('');
    const inputRef = useRef(null);
    const modalRef = useRef(null);

    useEffect(() => {
        if (isOpen) {
            setTitle('');
            setError('');
            setTimeout(() => {
                if (inputRef.current) {
                    inputRef.current.focus();
                }
            }, 0);
        }
    }, [isOpen]);

    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.key === 'Escape') {
                onClose();
            }
        };

        if (isOpen) {
            document.addEventListener('keydown', handleKeyDown);
        }

        return () => {
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [isOpen, onClose]);

    if (!isOpen) return null;

    const handleSave = async () => {
        if (!title) {
            setError('Meal plan name cannot be empty');
            return;
        }
        const response = await onSave(title);
        if (response && response.error) {
            setError(response.error);
        } else {
            setError('');
            onClose();
        }
    };

    return (
        <div className="modal-overlay mealplan-modal">
            <div className="modal-content" ref={modalRef}>
                <div className="modal-header">
                    <h2><i className="material-icons" style={{ marginRight: '5px', verticalAlign: 'top' }}>event_note</i>Add Meal Plan</h2>
                    <button title="Close" onClick={onClose} className="icon-button close-button"><i className="material-icons">close</i></button>
                </div>
                <div className="modal-body">
                    {error && <p className="error-message">{error}</p>}
                    <div className="search-input-container">
                        <input
                            ref={inputRef}
                            type="text"
                            placeholder="Meal Plan Name"
                            value={title}
                            onChange={(e) => setTitle(e.target.value)}
                            onKeyDown={(e) => e.key === 'Enter' && handleSave()}
                        />
                        {title && <button title="Clear name" onClick={() => { setTitle(''); inputRef.current.focus(); }} className="clear-input-button"><i className="material-icons">close</i></button>}
                    </div>
                </div>
                <div className="modal-footer">
                    <button title="Save and close" onClick={handleSave}>Save</button>
                    <button title="Cancel" onClick={onClose} className="cancel-button">Cancel</button>
                </div>
            </div>
        </div>
    );
};

export default AddMealPlanModal;
